import i18n from '@/i18n'

// VUE_APP_DEFAULT_SIM_TYPE=e_sim
const SIM_TYPES = ['real_sim', 'e_sim']

// VUE_APP_PRODUCTS_QUICK_FILTERS=Unlimited,Throttled,Limited
const QUICK_FILTERS_SETTINGS = {
    Unlimited: { type: 'set',   value: 'Unlimited', icon: 'clock-refresh',   title: `${i18n.t('unlimited')} ${i18n.t('data')}` },
    Throttled: { type: 'set',   value: 'Throttled', icon: 'speedometer',     title: `${i18n.t('endless')} ${i18n.t('data')}`   },
    Limited:   { type: 'set',   value: 'Limited',   icon: 'clock-stopwatch', title: `${i18n.t('capped')} ${i18n.t('data')}`    },
    reset:     { type: 'reset', value: '',          icon: 'refresh',         title: ''                                         },
}

export default {
    state: {},
    getters: {
        getEnvParam: () => param => process.env[param],
        getAppEnvParam: (state, getters) =>
            param => {
                const variable = param.split('-').join('_')
                return getters.getEnvParam(`VUE_APP_${variable}`)
            },

        app_environment: (state, getters) => getters.getAppEnvParam('ENVIRONMENT'),
        is_app_environment_prod: (state, getters) => getters.app_environment == 'prod',
        is_app_environment_email_verified: (state, getters) => getters.getAppEnvParam('IS_EMAIL_VERIFIED') == 'true',
        is_app_environment_enabled_i_already_have_sim_menu_item: (state, getters) => getters.getAppEnvParam('ENABLE_I_ALREADY_HAVE_SIM_MENU_ITEM') == 'true',
        is_app_environment_enabled_esim_menu_item: (state, getters) => getters.is_esim_available,
        is_app_environment_enabled_esim_confirmation: (state, getters) => getters.getAppEnvParam('ENABLE_ESIM_CONFIRMATION') == 'true',
        app_default_sim_type: (state, getters) => getters.default_sim_type,

        // SIM type a tenant starts an order with. Physical SIM when the tenant does not set one.
        app_environment_default_sim_type: (state, getters) => {
            const sim_type = getters.getAppEnvParam('DEFAULT_SIM_TYPE')

            return SIM_TYPES.includes(sim_type) ? sim_type : 'real_sim'
        },

        app_environment_group_mode: (state, getters) => getters.getAppEnvParam('GROUP_MODE'),
        is_app_environment_enabled_customer_groups_menu_item: (state, getters) => {
            return getters.app_environment_group_mode == 'ALL' || getters.app_environment_group_mode == 'CUSTOMER'
        },
        is_app_environment_enabled_mobile_groups_menu_item: (state, getters) => {
            return getters.app_environment_group_mode == 'ALL' || getters.app_environment_group_mode == 'MOBILE'
        },

        is_app_environment_allow_international_plans: (state, getters) => getters.getAppEnvParam('ALLOW_INTERNATIONAL_PLANS') == 'true',
        is_app_environment_enabled_voucher_menu_item: (state, getters) => getters.getAppEnvParam('ENABLE_VOUCHER_MENU_ITEM') == 'true',
        is_app_environment_enabled_promo_code_menu_item: (state, getters) => getters.getAppEnvParam('ENABLE_PROMO_CODE_MENU_ITEM') == 'true',
        is_app_environment_enabled_onboarding_voucher_redeem: (state, getters) => getters.getAppEnvParam('ENABLE_ONBOARDING_VOUCHER_REDEEM') == 'true',
        is_app_environment_enabled_bank_transactions: (state, getters) => getters.getAppEnvParam('ENABLE_BANK_TRANSACTIONS') == 'true',

        is_app_environment_show_no_plans_warning_on_addons: (state, getters) => getters.getAppEnvParam('IS_SHOW_NO_PLANS_WARNING_ON_ADDONS') == 'true',
        is_app_environment_allow_auto_renew_toggle_on_addons: (state, getters) => getters.getAppEnvParam('ALLOW_AUTO_RENEW_TOGGLE_ON_ADDONS') == 'true',
        is_app_environment_allow_auto_renew_toggle_on_plans: (state, getters) => getters.getAppEnvParam('ALLOW_AUTO_RENEW_TOGGLE_ON_PLANS') == 'true',
        is_app_environment_allow_auto_renew_toggle_on_purchase: (state, getters) => getters.getAppEnvParam('ALLOW_AUTO_RENEW_TOGGLE_ON_PURCHASE') == 'true',
        is_app_environment_show_confirmation_modal_on_purchase: (state, getters) => getters.getAppEnvParam('IS_SHOW_CONFIRMATION_MODAL_ON_PURCHASE') == 'true',

        // Whether a single order may mix local mobile SIMs and travel eSIMs.
        // Defaults to false (mutually exclusive) unless explicitly allowed.
        is_mixed_order_allowed: (state, getters) => getters.getAppEnvParam('IS_MIXED_ORDER_ALLOWED') == 'true',

        is_app_environment_billing_routing_allowed: (state, getters) => getters.getAppEnvParam('IS_BILLING_ROUTING_ALLOWED') == 'true',
        is_app_environment_billing_cycle_allowed: (state, getters) => getters.getAppEnvParam('IS_BILLING_CYCLE_ALLOWED') == 'true',
        is_app_environment_show_billing_type_on_dashboard: (state, getters) => getters.getAppEnvParam('IS_SHOW_BILLING_TYPE_ON_DASHBOARD') == 'true',
        is_app_environment_show_pay_bill_on_home: (state, getters) => getters.getAppEnvParam('IS_SHOW_PAY_BILL_ON_HOME') == 'true',

        is_app_environment_show_external_id_on_sign_up: (state, getters) => getters.getAppEnvParam('IS_SHOW_EXTERNAL_ID_ON_SIGN_UP') == 'true',
        is_app_environment_show_confirm_password_sign_up: (state, getters) => getters.getAppEnvParam('IS_SHOW_CONFIRM_PASSWORD_ON_SIGN_UP') == 'true',
        is_sign_up_allowed: (state, getters) => getters.getAppEnvParam('IS_SIGN_UP_ALLOWED') == 'true',
        is_show_note_on_eshop_cart_checkout: (state, getters) => getters.getAppEnvParam ('IS_SHOW_NOTE_ON_ESHOP_CART_CHECKOUT') == 'true',

        is_app_environment_invoices_allowed: (state, getters) => getters.getAppEnvParam('IS_INVOICES_ALLOWED') == 'true',
        is_app_environment_receipts_allowed: (state, getters) => getters.getAppEnvParam('IS_RECEIPTS_ALLOWED') == 'true',

        app_environment_sim_actions_allowed: (state, getters) => getters.getAppEnvParam('SIM_ACTIONS_ALLOWED') ? getters.getAppEnvParam('SIM_ACTIONS_ALLOWED').split(',') : [],
        is_sim_swap_allowed: (state, getters) => getters.app_environment_sim_actions_allowed.includes('SIM_SWAP'),
        is_sim_settings_allowed: (state, getters) => getters.is_app_environment_enabled_sim_settings_menu_item,
        is_sim_disable_enable_allowed: (state, getters) => getters.app_environment_sim_actions_allowed.includes('SIM_DISABLE_ENABLE'),
        is_sim_details_allowed: (state, getters) => getters.app_environment_sim_actions_allowed.includes('SIM_DETAILS'),
        is_show_puk_code_on_sim_details: (state, getters) => getters.getAppEnvParam('IS_SHOW_PUK_CODE_ON_SIM_DETAILS') == 'true',
        
        is_product_type_transfer_allowed: (state, getters) => getters.app_environment_sim_actions_allowed.includes('PRODUCT_TYPE_TRANSFER')
                                                                && getters.is_account_type_activated
                                                                && getters.curr_billing_reference_type
                                                                && getters.available_plans.length
                                                                && (getters.available_plans.length > 1 || getters.available_plans[0].toLowerCase() != getters.curr_billing_reference_type)
        ,
        is_number_porting_on_dashboard_allowed: (state, getters) => getters.app_environment_sim_actions_allowed.includes('NUMBER_PORTING_ON_DASHBOARD'),
        is_phone_number_change_on_dashboard_allowed: (state, getters) => getters.app_environment_sim_actions_allowed.includes('PHONE_NUMBER_CHANGE'),

        is_number_porting_on_checkout_allowed: (state, getters) => getters.getAppEnvParam('IS_NUMBER_PORTING_ON_CHECKOUT_ALLOWED') == 'true',
        is_afterpay_payment_module_allowed: (state, getters) => getters.getAppEnvParam('IS_AFTERPAY_PAYMENT_MODULE_ALLOWED') == 'true',
        is_phone_number_pre_select_on_checkout_allowed: (state, getters) => getters.getAppEnvParam('IS_PHONE_NUMBER_PRE_SELECT_ON_CHECKOUT_ALLOWED') == 'true',
        has_checkout_mobile_numbers_step: (state, getters) => getters.is_number_porting_on_checkout_allowed || getters.is_phone_number_pre_select_on_checkout_allowed,

        is_sim_actions_allowed: (state, getters) => getters.is_sim_swap_allowed || getters.is_sim_disable_enable_allowed || getters.is_sim_details_allowed || getters.is_product_type_transfer_allowed || getters.is_number_porting_on_dashboard_allowed,
        is_app_environment_enabled_sim_settings_menu_item: (state, getters) => {
            const features = getters.getAppEnvParam('SUP_FEATURES_ALLOWED')

            return !!features && features.split(',').filter(Boolean).length > 0
        },
        is_app_environment_enabled_purchase_addons_menu_item: (state, getters) => getters.getAppEnvParam('ENABLE_PURCHASE_ADDONS_MENU_ITEM') != 'false',
        
        is_app_environment_show_switch_plan: (state, getters) => getters.getAppEnvParam('IS_SHOW_SWITCH_PLAN') == 'true',
        is_app_environment_show_hotspot_param: (state, getters) => getters.getAppEnvParam('IS_SHOW_HOTSPOT_PARAM') == 'true',

        app_environment_products_quick_filters: (state, getters) => getters.getAppEnvParam('PRODUCTS_QUICK_FILTERS') ? getters.getAppEnvParam('PRODUCTS_QUICK_FILTERS').split(',') : [],
        has_app_environment_products_quick_filters: (state, getters) => Boolean(getters.app_environment_products_quick_filters.length),
        app_environment_products_quick_filters_mapped: (state, getters) => {
            if (!getters.has_app_environment_products_quick_filters) return [];
            if (getters.app_environment_products_quick_filters.some(quick_filter => !QUICK_FILTERS_SETTINGS[quick_filter])) return [];

            const products_quick_filters_mapped = getters.app_environment_products_quick_filters.map(quick_filter => {
                return QUICK_FILTERS_SETTINGS[quick_filter]
            })

            products_quick_filters_mapped.push(QUICK_FILTERS_SETTINGS.reset)

            return products_quick_filters_mapped
        },

        app_logo_outer_link: (state, getters) => getters.getAppEnvParam('LOGO_OUTER_LINK'),
        app_about_outer_link: (state, getters) => getters.getAppEnvParam('ABOUT_OUTER_LINK'),
        app_help_center_outer_link: (state, getters) => getters.getAppEnvParam('HELP_CENTER_OUTER_LINK'),
        price_overview_outer_link: (state, getters) => getters.getAppEnvParam('PRICE_OVERVIEW_OUTER_LINK'),
        is_app_go_to_sim_purchase_on_plans: (state, getters) => getters.getAppEnvParam('IS_GO_TO_SIM_PURCHASE_ON_PLANS') == 'true',
        app_reseller_api_host: (state, getters) => getters.getAppEnvParam('RESELLER_API_HOST'),

        oidc_origin: (state, getters) => getters.app_reseller_api_host,
        app_spid: (state, getters) => +getters.getAppEnvParam('SPID'),
        app_name: (state, getters) => getters.getAppEnvParam('NAME'),
        theme_name: (state, getters) => getters.getAppEnvParam('THEME'),
        layout_type: (state, getters) => getters.getAppEnvParam('LAYOUT') || 'first',
        is_app_support_service_intercom: (state, getters) => getters.getAppEnvParam('SUPPORT_SERVICE') == 'INTERCOM',
        is_app_support_service_gleap: (state, getters) => getters.getAppEnvParam('SUPPORT_SERVICE') == 'GLEAP',

        available_profile_tabs: (state, getters) => getters.getAppEnvParam('PROFILE_TABS') ? getters.getAppEnvParam('PROFILE_TABS').split(',') : [],

        available_broadband_profile_tabs: (state, getters) => getters.getAppEnvParam('UFB_PROFILE_TABS') ? getters.getAppEnvParam('UFB_PROFILE_TABS').split(',') : [],

        footer_copyright: (state, getters) => getters.getAppEnvParam('FOOTER_COPYRIGHT').replace('YYYY', (new Date()).getFullYear()),

        has_app_environment_dry_activation: (state, getters) => getters.getAppEnvParam('HAS_DRY_ACTIVATION') == 'true',

        is_multiple_sim_allowed: (state, getters) => getters.getAppEnvParam('IS_MULTIPLE_SIM_ALLOWED') == 'true',
        is_checkout_payment_confirmation: (state, getters) => getters.getAppEnvParam('IS_CHECKOUT_PAYMENT_CONFIRMATION') == 'true',
        is_show_header_info_on_checkout: (state, getters) => getters.getAppEnvParam('IS_SHOW_HEADER_INFO_ON_CHECKOUT') == 'true',
        plans_items_count_on_desktop_modal_carousel: (state, getters) => getters.getAppEnvParam('PLANS_ITEMS_COUNT_ON_DESKTOP_MODAL_CAROUSEL') == '3' ? 3 : 2,

        is_show_ufb_module: (state, getters, rootState, rootGetters) => rootGetters.is_module_ufb_enabled,
        is_show_fwa_module: (state, getters) => getters.getAppEnvParam('IS_SHOW_FWA_MODULE') === 'true',

        has_app_recaptcha: (state, getters) => Boolean(getters.getAppEnvParam('RECAPTCHA_KEY')),
        is_app_anonymous_recharge_allowed: (state, getters) => getters.getAppEnvParam('IS_ANONYMOUS_RECHARGE_ALLOWED') == 'true' && getters.has_app_recaptcha,
        is_app_anonymous_pay_bill_allowed: (state, getters) => getters.getAppEnvParam('IS_ANONYMOUS_PAY_BILL_ALLOWED') == 'true' && getters.has_app_recaptcha,
        has_multiple_broadband_services: (state, getters) => {
            return Boolean(getters.is_show_ufb_module && getters.is_show_fwa_module)
        }
    },
    actions: {},
    mutations: {}
}
